import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Spinner } from 'react-bootstrap'; // Import Spinner for the loader
import { clockin } from "../../../../../Routes/ImagePath";
import {
  Avatar_02,Avatar_01
} from "../../../../../Routes/ImagePath";
import { nodata } from "../../../../../Routes/ImagePath";

const EmployeeDashboard = () => {
    const [holidays, setHolidays] = useState([]);
    const [announcements, setAnnouncements] = useState([]);
    const [birthdayFolks, setBirthdayFolks] = useState([]);
    const [newHires, setNewHires] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [activities, setActivities] = useState([]);
    const [checkInTime, setCheckInTime] = useState(null);
    const [remainingTime, setRemainingTime] = useState(null);
    const [totalHours, setTotalHours] = useState(null);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [attendanceData, setAttendanceData] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("token");
    const cdnUrl = process.env.REACT_APP_CDN_URL;
    const empid = localStorage.getItem('empid');
    const [loading, setLoading] = useState(false);

    
      // Inside your component
      const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
      const [currentAnnouncement, setCurrentAnnouncement] = useState(null);

      // Function to handle opening the modal
      const handleShowAnnouncement = (announcement) => {
        setCurrentAnnouncement(announcement);
        setShowAnnouncementModal(true);
      };

      // Function to close the modal
      const handleCloseAnnouncement = () => {
        setShowAnnouncementModal(false);
      };

      // Function to strip HTML tags from the description
      const stripHtmlTags = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
      };


      useEffect(() => {
        // Fetch birthday employees data
        fetch(`${apiUrl}/employees/list?listtype=empbirthday`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        })
          .then(response => response.json())
          .then(data => {
            // Ensure data.employees is an array
            if (Array.isArray(data.employees)) {
              setBirthdayFolks(data.employees);
            } else {
              setBirthdayFolks([]); // Set to empty array if the employees list is not an array
            }
          })
          .catch(error => {
            console.error("Failed to fetch birthday employees:", error.message);
            setBirthdayFolks([]); // In case of error, set birthdayFolks to empty array
          });
      }, [apiUrl, token]);


    useEffect(() => {




        setNewHires([
            { name: "John Doe", position: "Junior Developer", startDate: "Jan 20 2024" },
            { name: "Jane Smith", position: "Product Manager", startDate: "Feb 05 2024" },
        ]);

        setTasks([
            { task: "Complete Performance Review", deadline: "Feb 25 2024" },
            { task: "Submit Monthly Report", deadline: "Feb 28 2024" },
        ]);

        setActivities([
            { activity: "Checked in at 9:00 AM", date: "Today" },
            { activity: "Approved leave for John Doe", date: "Yesterday" },
            { activity: "Checked out at 5:00 PM", date: "Yesterday" },
        ]);
    }, []);

    useEffect(() => {
      // Fetch attendance data
      if (empid) {
        fetch(`${apiUrl}/attendance/attendance-bydate?empid=${empid}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        })
        .then(response => {
          if (!response.ok) {
            return response.text().then(text => {
              throw new Error(`Error: ${response.status} - ${text}`);
            });
          }
          return response.json();
        })
        .then(data => {
          setAttendanceData(data);
          handleAttendanceData(data);
        })
        .catch(error => {
          console.error("Failed to fetch attendance data:", error.message);
        });
      }
    }, [empid]);
  
    useEffect(() => {
      // Fetch holidays data
      fetch(`${apiUrl}/holidays/list`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      })
      .then(response => response.json())
      .then(data => refineHolidays(data))
      .catch(error => console.error("Failed to fetch holidays data:", error.message));
    }, [token, apiUrl]);
  

    useEffect(() => {
  // Fetch announcements data
  fetch(`${apiUrl}/announcements/list?type=published`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // Filter only the published announcements
      const publishedAnnouncements = data.filter(announcement => announcement.status === true);

      // Transform data to match your component structure (if necessary)
      const transformedAnnouncements = publishedAnnouncements.map((announcement) => ({
        date: new Date(announcement.published_date).toLocaleDateString("en-US", { day: '2-digit', month: 'short' }).toUpperCase(),
        title: announcement.title,
        content: stripHtmlTags(announcement.description),
      }));

      setAnnouncements(transformedAnnouncements); // Set the transformed announcements
    })
    .catch((error) => {
      console.error("Failed to fetch announcements data:", error.message);
    });
}, [token, apiUrl]);

    const refineHolidays = (data) => {
      const today = new Date();
      const refinedHolidays = [];
    
      // Process each holiday and its dates
      data.forEach(holiday => {
        holiday.holiday_dates.forEach(date => {
          const holidayDate = new Date(date);
          const daysLeft = Math.ceil((holidayDate - today) / (1000 * 60 * 60 * 24));
    
          // Include only holidays that are today or in the future
          if (daysLeft >= 0) {
            refinedHolidays.push({
              name: holiday.holiday_name,
              date: date,
              daysLeft: daysLeft > 0 ? daysLeft : 0,
            });
          }
        });
      });
    
      // Sort holidays by date in descending order (most recent first)
      refinedHolidays.sort((b, a) => new Date(b.date) - new Date(a.date));
    
      // Select top 5 holidays
      const top5Holidays = refinedHolidays.slice(0, 5);
    
      setHolidays(top5Holidays);
    };
    
    const handleAttendanceData = (data) => {
      if (data.attendance_date) {
        // Split hours, minutes, and seconds from the hours_worked string
        const [hoursStr, minutesStr, secondsStr] = data.hours_worked.split(' ')[0].split(':');
        
        // Convert hours, minutes, and seconds to milliseconds
        const hoursWorkedMilliseconds = 
          (parseInt(hoursStr) * 3600 + parseInt(minutesStr) * 60 + parseInt(secondsStr)) * 1000;
    
        setTotalHours(hoursWorkedMilliseconds); // Initialize the clock with hours_worked in milliseconds
    
        const workHoursMilliseconds = 9 * 3600 * 1000; // 9 hours in milliseconds
    
        if (data.check_in_time && !data.check_out_time) {
          const checkInDateTime = new Date(`${data.attendance_date.split('T')[0]}T${convertTo24HourFormat(data.check_in_time)}`);
          setCheckInTime(checkInDateTime); // Set the check-in time to start the clock
    
          // Calculate remaining time
          const elapsedTimeMilliseconds = new Date() - checkInDateTime; // Time passed since check-in
          const remainingTimeMilliseconds = workHoursMilliseconds - (hoursWorkedMilliseconds + elapsedTimeMilliseconds);
          setRemainingTime(remainingTimeMilliseconds > 0 ? remainingTimeMilliseconds : 0); // Ensure it's not negative
        } else if (data.check_in_time && data.check_out_time) {
          calculateTotalHours(data.check_in_time, data.check_out_time, hoursWorkedMilliseconds);
          setRemainingTime(0); // No remaining time since they've checked out
        }
      }
    };
    
    const calculateTotalHours = (checkInTime, checkOutTime, initialHoursWorked) => {
      const checkInDate = new Date(`${attendanceData.attendance_date.split('T')[0]}T${convertTo24HourFormat(checkInTime)}`);
      const checkOutDate = new Date(`${attendanceData.attendance_date.split('T')[0]}T${convertTo24HourFormat(checkOutTime)}`);
      const totalWorkedMilliseconds = checkOutDate - checkInDate + initialHoursWorked;
    
      setTotalHours(totalWorkedMilliseconds);
    };
    
    // Helper function to convert 12-hour time format (e.g., "05:00:00 PM") to 24-hour time format (e.g., "17:00:00")
    const convertTo24HourFormat = (timeStr) => {
      const [time, modifier] = timeStr.split(' ');
      let [hours, minutes, seconds] = time.split(':');
    
      if (hours === '12') {
        hours = '00';
      }
    
      if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12;
      }
    
      return `${hours}:${minutes}:${seconds}`;
    };
    
  
    useEffect(() => {
      if (checkInTime) {
        const interval = setInterval(() => {
          setTotalHours(prevTotal => prevTotal + 1000); // Increment totalHours by 1 second (1000 milliseconds)
          setRemainingTime(prevRemaining => prevRemaining > 0 ? prevRemaining - 1000 : 0); // Decrement remainingTime by 1 second if it's not 0
        }, 1000);
        return () => clearInterval(interval);
      }
    }, [checkInTime]);
  
    const formatTime = (milliseconds) => {
      const totalSeconds = Math.floor(milliseconds / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${hours} Hrs ${minutes} Min ${seconds} Sec`;
    };
  
    const handleCheckIn = () => {  
      if (loading) return; // Prevent further clicks if loading
      setLoading(true); // Start loading state
  
      if (checkInTime) {
          // Check-out scenario
          fetch(`${apiUrl}/attendance/add`, {
              method: 'POST',
              headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  emp_id: empid,
                  "attendance_type": "out",
              }),
          })
          .then(response => response.json())
          .then(data => {
              setAttendanceData(data);
      
              // Parse hours, minutes, and seconds from hours_worked in response
              const [hoursStr, minutesStr, secondsStr] = data.hours_worked.split(' ')[0].split(':');
              const hoursWorkedMilliseconds = 
                (parseInt(hoursStr) * 3600 + parseInt(minutesStr) * 60 + parseInt(secondsStr)) * 1000;
            
              setTotalHours(hoursWorkedMilliseconds); // Update total hours worked
              setCheckInTime(null); // Stop the clock
              setRemainingTime(0); // Reset remaining time
              setLoading(false); // Stop loading state
          })
          .catch(error => {
              console.error("Failed to check out:", error.message);
              setLoading(false); // Stop loading state in case of error
          });
      } else {
          // Check-in scenario
          fetch(`${apiUrl}/attendance/add`, {
              method: 'POST',
              headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  emp_id: empid,
                  "attendance_type": "in",
              }),
          })
          .then(response => response.json())
          .then(data => {
              setAttendanceData(data);
      
              // Parse hours, minutes, and seconds from hours_worked in response
              const [hoursStr, minutesStr, secondsStr] = data.hours_worked.split(' ')[0].split(':');
              const hoursWorkedMilliseconds = 
                (parseInt(hoursStr) * 3600 + parseInt(minutesStr) * 60 + parseInt(secondsStr)) * 1000;
            
              setTotalHours(hoursWorkedMilliseconds); // Start the clock from the hours worked
      
              const checkInDateTime = new Date(`${data.attendance_date.split('T')[0]}T${convertTo24HourFormat(data.check_in_time)}`);
              setCheckInTime(checkInDateTime); // Set the check-in time to start the clock from the server time
            
              setLoading(false); // Stop loading state
          })
          .catch(error => {
              console.error("Failed to check in:", error.message);
              setLoading(false); // Stop loading state in case of error
          });
      }
  };
  
    

    return (
      <div className="page-wrapper">
        <div className="content container-fluid pb-0">

        <div className="row mb-4">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center p-3 clockin">
                <div className="clock-in-content d-flex align-items-center" style={{ backgroundColor: '#f5f7f9 ', padding: '10px', borderRadius: '5px' }}>
                  <h6 className="mb-0">{totalHours ? formatTime(totalHours) : "0 Hrs 00 Min 00 Sec"}</h6>
                </div>
                <div className="clock-in-btn d-flex align-items-center">
                  <button onClick={handleCheckIn} className="btn btn-primary me-3" disabled={loading}>
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <img src={clockin} alt="Icon" />
                    )}
                    {checkInTime ? " Check-out" : " Clock-In"}
                  </button>
                  <Link to="/leaves-employee" className="btn btn-outline-primary">Apply Leave</Link>
                </div>
              </div>
            </div>
          </div>

          <div className="dashboard-container">
            <div className="info-card">
              <h4>Upcoming Holidays</h4>
              <div className="holiday-details">
                {holidays.map((holiday, index) => (
                  <div key={index} className="holiday-calendar">
                    <div className="holiday-date">
                      <h5>{new Date(holiday.date).getDate()}</h5>
                      <p>{new Date(holiday.date).toLocaleString('default', { month: 'short' }).toUpperCase()}</p>
                    </div>
                    <div className="holiday-calendar-content">
                      <h6>{holiday.name}</h6>
                      <p>{holiday.date}</p>
                    </div>
                    <div className="holiday-days-left">
                      <p>{holiday.daysLeft} days to left</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

  <div className="info-card">
  <h4>Announcements</h4>
  <div className="announcement-details">
    {announcements.length === 0 ? (
  
  <div className="no-data">
  <img src={nodata} alt="" />

  <p>No Announcement posted recently.</p>
</div>

) : (
      announcements.map((announcement, index) => (
        <div key={index} className="announcement-item">
          <div className="announcement-date">
            <h5>{announcement.date.split(' ')[1]}</h5>
            <p>{announcement.date.split(' ')[0]}</p>
          </div>
          <div className="announcement-content">
            <h6>{announcement.title}</h6>
            <p>
              {announcement.content.length > 50
                ? announcement.content.substring(0, 50) + '...'
                : announcement.content}
            </p>
            {announcement.content.length > 50 && (
              <button className="btn btn-link p-0" onClick={() => handleShowAnnouncement(announcement)}>
                Read more
              </button>
            )}
          </div>
        </div>
      ))
    )}
  </div>



      {/* Announcement Modal */}
      <Modal show={showAnnouncementModal} onHide={handleCloseAnnouncement}>
      <Modal.Header closeButton>
        <Modal.Title>{currentAnnouncement?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: currentAnnouncement?.content }}></div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseAnnouncement}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  </div>


            <div className="info-card">
              <h4>Birthday</h4>
              <div className="birthday-details">
      {birthdayFolks.length === 0 ? (

        <div className="no-data">
        <img src={nodata} alt="" />

        <p>No Birthdays Today</p> 
      </div>

      ) : (
        birthdayFolks.map((person, index) => (
          <div key={index} className="birthday-item">
            <div className="birthday-avatar">
           
                      <Link to={`/profile/${person.id}`}>
                                    <img 
                  src={person.profile_pic 
                        ? `${cdnUrl}/${person.profile_pic}` 
                        : (person.gender === 'male' ? Avatar_01 : Avatar_02)
                      }
                  alt="Employee Avatar"  className="rounded-circle shadow"
                />
                      </Link>
            </div>
            <div className="birthday-content">
              <h6>{person.empcode} - {person.name}</h6>
              <p>{person.designation_name}</p>
              <p>{person.department_name}</p>

            </div>
          </div>
        ))
      )}
    </div>
            </div>
          </div>

          {/* New Row */}
          <div className="dashboard-container">
            <div className="info-card">
              <h4>New Hires</h4>
              <div className="new-hires-details">
                {newHires.map((hire, index) => (
                  <div key={index} className="hire-item">
                    <h6>{hire.name}</h6>
                    <p>{hire.position}</p>
                    <p>Start Date: {hire.startDate}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="info-card">
              <h4>My Tasks</h4>
              <div className="tasks-details">
                {tasks.map((task, index) => (
                  <div key={index} className="task-item">
                    <h6>{task.task}</h6>
                    <p>Deadline: {task.deadline}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="info-card">
              <h4>My Activity</h4>
              <div className="activity-details">
                {activities.map((activity, index) => (
                  <div key={index} className="activity-item">
                    <h6>{activity.activity}</h6>
                    <p>{activity.date}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default EmployeeDashboard;
